module.exports = require("!!vue-loader!../../../node_modules/vue-markdown-loader/lib/markdown-compiler.js?raw!./terms.md");


//////////////////
// WEBPACK FOOTER
// ./client/models/content/terms.md
// module id = 432
// module chunks = 0